export default __webpack_public_path__ + "styles/icons/empty1000mLFlask.svg";